import { gql } from '@apollo/client';

import { FileInfoFragment } from '@modules/shared/graphql';

export const TestResultsQuestionFragment = gql`
    fragment TestResultsQuestion on OLTestResultsQuestion {
        id
        text
        photos {
            ...FileInfo
        }
        answers {
            id
            text
            photo {
                ...FileInfo
            }
            userAnswered
            isCorrect
        }
    }
    ${FileInfoFragment}
`;
